"use client";

import Head from "next/head";

export default function CustomHead() {
  return (
    <Head>
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="theme-color" content="#000000"></meta>

      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#000000" />
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/css/flag-icons.min.css"
      />

      <script
        async
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      ></script>
      {/* <script async src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1876161059746184`} crossOrigin="anonymous"></script> */}
      {/* <GoogleAdSense googleAdSenseId={process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_CLIENT_ID} /> */}
      <script
        async
        src="https://cdnjs.cloudflare.com/ajax/libs/phaser/3.87.0/phaser.min.js"
      ></script>
    </Head>
  );
}
